/**
 * Created by Vladislav on 18.09.2024.
 */

cleverapps.InitByFeature["lives"] = function (isNewUser) {
    cleverapps.unlimitedLives = new UnlimitedLives();

    LivesHelper.Initialize(isNewUser);
};